import { match } from 'ts-pattern';

import type { EmailInUseError } from './resolve-email-in-use-error';

type EmailInUseMessage = {
    message: string;
    // The phrase a form appends as " or <phrase>".
    useExisting: string;
};

export function formatEmailInUseMessage(holder: EmailInUseError['holder']): EmailInUseMessage {
    return match(holder)
        .with({ kind: 'CLIENT' }, ({ name }) => ({
            message: `This email is attached to existing client, ${name}. Change email`,
            useExisting: 'use existing client',
        }))
        .with({ kind: 'CONTACT' }, ({ name }) => ({
            message: `This email is attached to existing contact, ${name}. Change email`,
            useExisting: 'use existing contact',
        }))
        .exhaustive();
}
